import React from 'react'

import { FilterOption, FilterTrigger, useFilterRowLabels } from '../../../../design-system/FilterTrigger'

interface IImportPickerProps {
  id: string
  options: FilterOption[]
  value?: string
  /** Shown while nothing is picked. */
  placeholder: string
  onChange: (value: string) => void
}

/**
 * A single-choice department or location picker, the same searchable, nested control the Users page uses.
 * Quiet keeps the trigger reading just the picked name, since the column header already names the field.
 */
const ImportPicker = ({ id, options, value, placeholder, onChange }: IImportPickerProps): React.ReactElement => {
  const labels = useFilterRowLabels()
  const picked = options.find((option) => option.value === value)
  return (
    <FilterTrigger
      config={{ id, label: picked?.label ?? placeholder, options, multiple: false, searchable: true }}
      value={value ? [value] : []}
      onChange={(next) => next[0] && onChange(next[0])}
      clearable={false}
      quiet
      emptyLabel={labels.noOptions}
      searchLabel={labels.search}
      noResultsLabel={labels.noResults}
      expandGroupLabel={labels.expandGroup}
      collapseGroupLabel={labels.collapseGroup}
    />
  )
}

export default ImportPicker
